import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from '../../../../utils/confg.json'
const url = config.BackendUrl;
//| 'pending' | 'succeeded' | 'failed',
const initialState = {
  response: {},
  loading: 'idle',
  httpCode: 0,
  errorMsg: "",
  errorData: {},
};


export const getAllStoreSetting = createAsyncThunk(
  "getAllStoreSetting/getAllStoreSetting",

  async (dispatch, { rejectWithValue }) => {
    try {

      const shopId = dispatch.shopId


      const { data } = await axios.get(url + "/Apps/API/CMS/Settings/Store/getAll?ShopId=" + shopId + "&DeviceId=0&QRKey=0",
        {
          withCredentials: true
        })
      return data;
    } catch (err) {


      if (err.response) {
        return rejectWithValue({ error: err.message, status: err.response.status, data: err.response.data });


      }


    }
  }
);








export const GetAllStoreSettingSlices = createSlice({

  name: "GetAllStoreSetting",
  initialState,

  reducers: {
    reset: () => initialState
  },
  extraReducers: {
    [getAllStoreSetting.pending]: (state) => {
      state.loading = 'pending';
    },
    [getAllStoreSetting.fulfilled]: (state, action) => {

      state.loading = 'succeeded';
      state.httpCode = 200;
      state.response = action.payload;
    },
    [getAllStoreSetting.rejected]: (state, action) => {

      try {
        state.loading = 'failed';
        state.httpCode = action.payload.status;
        state.errorMsg = action.payload.error;
        state.response = {};
        if (action.payload.status === 409) {
          state.errorData = action.payload.data
        } else {

          state.response = {}

        }
      } catch {

        state.httpCode = 503;
        state.errorMsg = "service unavailable";
      }
    }








  }

})

export const { reset } = GetAllStoreSettingSlices.actions

export default GetAllStoreSettingSlices.reducer;